import {
  BUSINESS_TYPE_VALUE,
  COMPANY_VALUE,
  FIELD_NAMES_CSV,
  KEYS_EXCLUDED_CSV,
  SUB_USE_CASES_CSV,
} from 'containers/pages/Messaging/CampaignDialog/constants';
import { IEnablementInfoV3 } from 'interface/WizardV3';
import { DATE_FORMATS, formatDate } from './date-helpers';

interface IProps {
  json: IEnablementInfoV3;
  submissionDate: string;
  status: string;
}
interface IAccum {
  key: string;
  name: string;
  newIndex: number;
}

const filterKeys = (json: IEnablementInfoV3) => {
  const accumulator = Object.keys(json).reduce((array: IAccum[], key) => {
    if (
      json[key] !== null &&
      json[key] !== undefined &&
      !KEYS_EXCLUDED_CSV.includes(key)
    ) {
      array.push({
        key,
        newIndex: FIELD_NAMES_CSV[key].index,
        name: FIELD_NAMES_CSV[key].name,
      });
    }
    return array;
  }, []);
  const sortedAcc: IAccum[] = accumulator.sort(
    (a: IAccum, b: IAccum) => a.newIndex - b.newIndex,
  );
  return sortedAcc;
};

const convertJsonToCsv = (json: IEnablementInfoV3) => {
  const acc = filterKeys(json);
  const table: string[][] = [['Field Name', 'Field Value']];

  acc.forEach((item) => {
    let value;
    if (item.key === 'creationDate' || item.key === 'updateDate') {
      value = formatDate(new Date(json[item.key]), DATE_FORMATS.SHORT);
    } else if (item.key === 'companyType') {
      value = COMPANY_VALUE[json[item.key]];
    } else if (item.key === 'typeOfBusiness') {
      value = JSON.stringify(BUSINESS_TYPE_VALUE[json[item.key]]);
    } else if (typeof json[item.key] === 'boolean') {
      value = json[item.key] ? 'Yes' : 'No';
    } else if (item.key === 'numberOfLines') {
      value =
        json[item.key].toString() === '40'
          ? '40 numbers or less'
          : '41 numbers or more';
    } else if (item.key === 'useCase') {
      value = SUB_USE_CASES_CSV[json[item.key]];
    } else if (item.key === 'subUseCases') {
      const subUseCases = json[item.key]
        .split(',')
        .map((subUseCase) => {
          return SUB_USE_CASES_CSV[
            subUseCase as keyof typeof SUB_USE_CASES_CSV
          ];
        })
        .join(', ');
      value = JSON.stringify(subUseCases);
    } else if (item.key === 'corpAcctNbr') {
      value = `<${json[item.key]}>`;
    } else if (item.key === 'addressZipCode') {
      value = `<${json[item.key]}>`;
    } else if (
      item.key === 'messageFlowDescription' ||
      item.key === 'campaignDescription' ||
      item.key === 'optinMessage' ||
      item.key === 'optoutMessage' ||
      item.key === 'supportMessage' ||
      item.key === 'sampleMessageOne' ||
      item.key === 'sampleMessageTwo' ||
      item.key === 'sampleMessage3' ||
      item.key === 'sampleMessage4' ||
      item.key === 'sampleMessage5'
    ) {
      const init = json[item.key].replace(/"/g, '');
      value = JSON.stringify(init);
    } else {
      value = JSON.stringify(json[item.key]);
    }

    table.push([item.name, value]);
  });

  let csvContent = '';
  table.forEach((row) => {
    csvContent += `${row.join(',')}\n`;
  });

  return csvContent;
};

export function downloadEnablementCsv({
  json,
  submissionDate,
  status,
}: IProps) {
  const csv = convertJsonToCsv(json);
  const csvDownloadLink = document.createElement('a');

  const file = new Blob([csv], { type: 'text/csv;charset=utf-8,' });
  csvDownloadLink.href = URL.createObjectURL(file);
  csvDownloadLink.download = `Business messaging registration - ${submissionDate} - ${status}.csv`;
  csvDownloadLink.click();
}
